import Vue from "vue";
import store from "../store/index";

/**
 * 控制按钮是否显示
 *
 * 接收一个数组 ：按钮要显示的平台
 */
export const btnPermission = Vue.directive("btnPermission", {
  inserted: function(el, binding, vnode) {
    let phoneModel = store.state.app.phoneModel || localStorage.getItem('phoneModel');
    let arg = binding.value;
    if (!arg.includes(phoneModel)) {
      el.parentNode.removeChild(el);
    }
  }
});



// WEBPACK FOOTER //
// ./src/directives/btn-permission.js